import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import ColorPicker from '@/pages/design/components/ColorPicker';
import Card from '@/pages/design/components/Card';
import CardItem from '@/pages/design/components/CardItem';
import Title from '@/pages/design/components/Title';
import InputBar from '@/pages/design/components/InputBar';
export default {
  i18n: require('../../design_i18n'),
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    ColorPicker: ColorPicker,
    Card: Card,
    CardItem: CardItem,
    Title: Title,
    InputBar: InputBar
  },
  computed: {
    slideStyle: function slideStyle() {
      if (this.show) {
        return "\n      opacity: 1;\n      \n      visibility: visible;\n      ";
      } else {
        return "\n      opacity: 0;\n      \n      visibility: hidden;\n      ";
      }
    }
  },
  data: function data() {
    return {
      form: this.$form.createForm(this),
      langList: []
    };
  },
  created: function created() {
    var _this = this;
    var langListStr = localStorage.getItem('langList');
    var defaultLangStr = localStorage.getItem('defaultLangObj');
    var langList = langListStr && JSON.parse(langListStr) || [];
    var defaultLangObj = defaultLangStr && JSON.parse(defaultLangStr) || {};
    this.langList = langList.map(function (lang) {
      if (lang.langId === defaultLangObj.langId) {
        lang.required = true;
      }
      if (typeof _this.value.main.title[lang.langId] === 'undefined') {
        _this.$set(_this.value.main.title, lang.langId, '');
      }
      return lang;
    });
  },
  methods: {}
};